/* GENERADO por horizon/tools/gen-japa.cjs. NO editar a mano. Motor de sonido, volteo del 108 y logica VERBATIM de japa-rueda-v2.html; solo el boot y los overlays llevan parche quirurgico (ver el generador). */

(function () {
  "use strict";

  try {
  var QA = (window.MP_QA === true);
  var root = document.querySelector('[data-mp-japa]');
  if (!root) { return; }
  var room = root.querySelector('[data-room]');
  if (!room) { return; }
  document.documentElement.classList.add('mp-app');
  room.hidden = false;
  if (window.MP_QA_BOOT_FAIL) { throw new Error('qa-boot-fail'); }

  /* ===================== constantes ===================== */
  var BASE_HZ = 175;                       // la base sellada del contador (marimba honda)
  var BASE_HZ_ORIGINAL = 175;              // espejo de la base sellada: el chip 432 escala BASE_HZ sobre este
  var LLAVE_AFINACION = 'mp_japa_afinacion_v1'; // '0' = 432 apagado; ausente o cualquier otro valor = encendido (default)
  var LLAVE = 'mp_japa_practica_v1';       // el japa vive en su propio mundo (misma llave, campos aditivos)
  var TOTAL = 108;
  var ULTIMA = TOTAL - 1;

  /* ===================== los hitos de vueltas (hereda estado-v3-diseno.txt) =====================
     La serie sellada 9/27/45/81/108/216/432/864/1111 sobre el TOTAL de vueltas completadas
     (estado.vueltas, historico que jamas baja). El hito se dispara SOLO en el instante en que
     vueltas entra a la serie: como el incremento es siempre +1 (jamas salta un valor), es imposible
     perder un hito y no hace falta guardar "vistos" (cero almacenamiento extra). Despues de 1111 el
     camino sigue en silencio, sin pantallas. Cada clave es su numero; el valor, la linea que une el
     numero con su sentido. Verbatim y sin guion largo (regla de la casa). */
  var HITOS = {
    9:    'nueve, el primer circulo que se cierra',
    27:   'veintisiete, la potencia del tres',
    45:   'cuarenta y cinco, el codificador de la casa',
    81:   'ochenta y uno, el nueve elevado a si mismo',
    108:  'ciento ocho, el numero del mala: una vuelta por cada cuenta',
    216:  'doscientos dieciseis, el mala que se dobla',
    432:  'cuatrocientos treinta y dos, la frecuencia del universo',
    864:  'ochocientos sesenta y cuatro, el numero del Sol',
    1111: 'mil ciento once, el portal'
  };
  var hitoPendiente = 0;                    // el numero de vueltas que espera su pantalla al cerrar la ceremonia


  // LIBRE · el centinela de "Solo contar": la vuelta del mala SIN mantra. Campos vacios para que cada
  // uso del mantra activo (.texto/.nombre/.fonetica/.clase/.cat/.largo...) sea seguro; el nombre visible
  // es "Solo contar" y el centro de la rueda queda vacio.
  var LIBRE = { id: 'libre', cat: -1, nombre: 'Solo contar', texto: '', clase: 'corto', fonetica: '',
    esencia: '', tradicion: '', largo: false, linea1: '' };
  function mantraPorId(id) { if (id === 'libre') { return LIBRE; } for (var i = 0; i < MANTRAS.length; i++) { if (MANTRAS[i].id === id) { return MANTRAS[i]; } } return MANTRAS[0]; }
  function idxMantra(id) { for (var i = 0; i < MANTRAS.length; i++) { if (MANTRAS[i].id === id) { return i; } } return 0; }

  /* [GANCHO OLA 2] EL ASCENSO DEL ESPECTRO: los 7 chakras, una vuelta cada uno. La ola 2 interpola la
     atmósfera (--atm-halo, --atm-fondo) 1/108 por cuenta entre el chakra actual y el siguiente; tras la
     séptima, un blanco dorado pleno. La UI jamás cambia de color: solo estas variables. */
  var CHAKRAS = [
    { halo: 'rgba(196, 62, 52, .16)',  fondo: '#1D1210' }, // raíz · rojo
    { halo: 'rgba(210, 116, 46, .16)', fondo: '#1E140C' }, // sacro · naranja
    { halo: 'rgba(214, 176, 74, .16)', fondo: '#1C170C' }, // plexo · dorado
    { halo: 'rgba(96, 176, 104, .15)', fondo: '#111A11' }, // corazón · verde
    { halo: 'rgba(74, 148, 210, .15)', fondo: '#0E1620' }, // garganta · azul
    { halo: 'rgba(96, 96, 196, .16)',  fondo: '#12111E' }, // tercer ojo · índigo
    { halo: 'rgba(150, 96, 200, .16)', fondo: '#170F1C' }, // corona · violeta
    { halo: 'rgba(240, 223, 174, .18)', fondo: '#1B160D' } // pleno · blanco dorado, tras la séptima
  ];

  /* ---------- el calendario local (patrón claveDia sellado) ---------- */
  function claveDia(d) {
    var y = d.getFullYear(), m = d.getMonth() + 1, dd = d.getDate();
    return y + '-' + (m < 10 ? '0' + m : m) + '-' + (dd < 10 ? '0' + dd : dd);
  }
  var HOY_STR = claveDia(new Date());
  var QS = (function () { try { if (window.__MP_QS) { return String(window.__MP_QS); } } catch (e) {} return location.search; })();

  /* ===================== estado ampliado (mp_japa_practica_v1) =====================
     Campos sellados de la ronda 1: cuenta, sentido, vueltas, vueltasHoyDia, vueltasHoyN, modo, mantraId.
     Campos nuevos de la v2: modoAuto, ritmoCiclo, tonoRespira, marcadoresOn, vozRespira. */
  var estado = {
    cuenta: 0, sentido: 1, vueltas: 0,
    vueltasHoyDia: null, vueltasHoyN: 0,
    modo: 'mantra', mantraId: 'om',
    modoAuto: false, ritmoCiclo: 10, tonoRespira: 50, marcadoresOn: true,
    vozRespira: 'c'
  };
  var empezado = false;
  var enCima = false;

  function cargar() {
    try {
      var raw = JSON.parse(localStorage.getItem(LLAVE) || 'null');
      if (raw && typeof raw === 'object') {
        estado.cuenta = Math.min(ULTIMA, Math.max(0, raw.cuenta | 0));
        estado.sentido = (raw.sentido === -1) ? -1 : 1;
        estado.vueltas = Math.max(0, raw.vueltas | 0);
        estado.vueltasHoyDia = raw.vueltasHoyDia || null;
        estado.vueltasHoyN = Math.max(0, raw.vueltasHoyN | 0);
        estado.modo = (raw.modo === 'respiracion') ? 'respiracion' : 'mantra';
        estado.mantraId = mantraPorId(typeof raw.mantraId === 'string' ? raw.mantraId : 'om').id;
        estado.modoAuto = (raw.modoAuto === true);
        estado.ritmoCiclo = Math.min(14, Math.max(6, (typeof raw.ritmoCiclo === 'number') ? raw.ritmoCiclo : 10));
        estado.tonoRespira = 50; // el tono OPTIMO para relajar, SELLADO por su oido (4-jul); el slider se retiro
        estado.marcadoresOn = (raw.marcadoresOn !== false);
        estado.vozRespira = 'c'; // la marea, SELLADA por su oído (4-jul); a/b/d quedan de referencia en el código
        empezado = (estado.cuenta > 0 || estado.sentido === -1 || estado.vueltas > 0);
      }
    } catch (e) { /* sin memoria local: la práctica sigue, solo no se recuerda */ }
  }
  function guardar() { try { localStorage.setItem(LLAVE, JSON.stringify(estado)); } catch (e) {} }
  function vueltasHoy() { return (estado.vueltasHoyDia === HOY_STR) ? estado.vueltasHoyN : 0; }
  function registrarVuelta() {
    estado.vueltas += 1;
    if (estado.vueltasHoyDia === HOY_STR) { estado.vueltasHoyN += 1; }
    else { estado.vueltasHoyDia = HOY_STR; estado.vueltasHoyN = 1; }
    // este es el UNICO punto de incremento real: si vueltas acaba de entrar a la serie, el hito
    // queda pendiente y lo despierta toque() al cerrar la ceremonia del volteo (jamas encima de ella).
    if (HITOS[estado.vueltas]) { hitoPendiente = estado.vueltas; }
  }

  /* ===================== la cuerda: madera noble ensartada ===================== */
  function hexRgb(hex) { hex = hex.replace('#', ''); return [parseInt(hex.substr(0, 2), 16), parseInt(hex.substr(2, 2), 16), parseInt(hex.substr(4, 2), 16)]; }
  function enStops(stops, t) {
    t = Math.max(0, Math.min(1, t));
    var segs = stops.length - 1, pos = t * segs, idx = Math.min(segs - 1, Math.floor(pos)), lt = pos - idx;
    var a = hexRgb(stops[idx]), b = hexRgb(stops[idx + 1]);
    return 'rgb(' + [0, 1, 2].map(function (i) { return Math.round(a[i] + (b[i] - a[i]) * lt); }).join(',') + ')';
  }
  var CUERDA = ['#4A3526', '#6E4A2E', '#8A5A32', '#A6743C', '#C79A55', '#A6743C', '#8A5A32', '#6E4A2E', '#4A3526'];
  function colorCuenta(i) { return enStops(CUERDA, i / ULTIMA); }

  /* los marcadores sagrados (repeticiones 27/45/54/81 -> cuentas físicas 26/44/53/80) */
  var SAGRADAS = { 26: true, 44: true, 53: true, 80: true };
  /* [PIEZA 5] la voz de cada marcador al pasar: un armónico más hondo y más quedo que la voz normal, con
     una háptica breve propia. Nunca interrumpe: se posa debajo de la cuenta. mul = altura respecto a la
     base (todas por debajo de la voz, "más hondas"); dur = su cola; vib = su tacto distinto. */
  var MARCADOR_VOZ = {
    26: { mul: 0.500, dur: 0.85, vib: [16] },                 // 27 · una octava abajo: una campana sola
    44: { mul: 0.375, dur: 1.05, vib: [14, 46, 14] },         // 45 · el de los códigos: el más hondo, doble pulso
    53: { mul: 0.667, dur: 0.95, vib: [10, 34, 10, 34, 10] }, // 54 · la mitad del mala: tres pulsos quedos
    80: { mul: 0.750, dur: 0.80, vib: [20] }                  // 81 · una cuarta abajo: un tono sereno
  };

  /* ===================== la rueda visual: 108 cuentas + gurú ===================== */
  var elVisual = document.getElementById('anillo-visual');
  var beads = [];
  function construirRueda() {
    var GAP = 30, arco = 360 - GAP, paso = arco / ULTIMA;
    var inicio = 180 + GAP / 2;
    for (var i = 0; i < TOTAL; i++) {
      var ang = inicio + i * paso;
      var wrap = document.createElement('span');
      wrap.className = 'mala-cuenta';
      if (SAGRADAS[i]) { wrap.className += ' es-sagrada'; if (i === 53) { wrap.className += ' es-media'; } }
      else if (i % 9 === 0) { wrap.className += ' es-nueve'; }
      wrap.style.transform = 'translate(-50%, -50%) rotate(' + ang + 'deg) translateY(calc(var(--mala-r) * -1))';
      var dot = document.createElement('span');
      dot.className = 'mala-dot';
      dot.style.setProperty('--c', colorCuenta(i));
      wrap.appendChild(dot);
      elVisual.appendChild(wrap);
      beads.push(wrap);
    }
  }
  function pintarRueda() {
    var c = estado.cuenta;
    for (var i = 0; i < TOTAL; i++) {
      var recorrida = empezado && i <= c && i !== c;
      var actual = empezado && i === c;
      beads[i].classList.toggle('is-recorrida', recorrida);
      beads[i].classList.toggle('is-actual', actual);
    }
  }
  function destellarCuenta(i) {
    if (i < 0 || i >= TOTAL) { return; }
    var el = beads[i];
    el.classList.add('mp-pulso');
    window.setTimeout(function () { el.classList.remove('mp-pulso'); }, 220);
  }

  /* [PIEZA 4] EL ASCENSO DEL ESPECTRO. La atmósfera (el halo detrás del anillo + el tinte del fondo) sube
     por los 7 chakras, una vuelta cada uno, interpolando 1/108 por cuenta entre el chakra en curso y el
     siguiente: imperceptible toque a toque, nítido al mirar después. La vuelta que se vive es
     (vueltas + 1); su color = CHAKRAS[vueltas]. Tras la 7ª, el blanco dorado pleno se queda. La UI (oro,
     textos, chips) jamás cambia: solo estas dos variables. reduced-motion = pasos discretos por vuelta. */
  var elAppAtm = document.getElementById('app');
  function parseColor(str) {
    if (str.charAt(0) === '#') { var c = hexRgb(str); return [c[0], c[1], c[2], 1]; }
    var m = /rgba?\(([^)]+)\)/.exec(str); if (!m) { return [0, 0, 0, 1]; }
    var p = m[1].split(',');
    return [parseFloat(p[0]), parseFloat(p[1]), parseFloat(p[2]), (p.length > 3) ? parseFloat(p[3]) : 1];
  }
  function mezclaColor(a, b, t) {
    var A = parseColor(a), B = parseColor(b);
    return 'rgba(' + Math.round(A[0] + (B[0] - A[0]) * t) + ',' + Math.round(A[1] + (B[1] - A[1]) * t)
      + ',' + Math.round(A[2] + (B[2] - A[2]) * t) + ',' + (Math.round((A[3] + (B[3] - A[3]) * t) * 1000) / 1000) + ')';
  }
  function fraccionEnPasada() { // 0 al empezar la pasada, casi 1 al cerrarla (en ambos sentidos)
    if (!empezado) { return 0; }
    return (estado.sentido > 0) ? (estado.cuenta / TOTAL) : ((ULTIMA - estado.cuenta) / TOTAL);
  }
  function aplicaAtmosfera() {
    if (!elAppAtm) { return; }
    var v = Math.max(0, estado.vueltas);
    var i0 = Math.min(7, v), i1 = Math.min(7, v + 1), frac;
    if (mqReduce.matches) { i1 = i0; frac = 0; }   // pasos discretos: la vuelta en curso, sin interpolar
    else { frac = fraccionEnPasada(); }
    elAppAtm.style.setProperty('--atm-halo', mezclaColor(CHAKRAS[i0].halo, CHAKRAS[i1].halo, frac));
    elAppAtm.style.setProperty('--atm-fondo', mezclaColor(CHAKRAS[i0].fondo, CHAKRAS[i1].fondo, frac));
  }

  /* ===================== el motor de sonido (portado fiel del chasis D sellado) =====================
     [GANCHO OLA 2] "sonido más sutil": la ola 2 recalibra esta voz del japa (bajar gains, suavizar
     ataque, redondear timbre, más aire de reverberación). Hoy conserva la voz sellada de la ronda 1. */
  var audioCtx = null, masterGain = null, reverbNode = null, dronNodo = null, swellNodo = null;
  var audioDespierto = false, fondoAutoDisparado = false;
  var sonidoOn = true, fondoOn = true;
  var wakeLock = null, sesionActiva = false;

  /* el chip 432 (el fondo opcional del fundador, encendido por defecto): un solo apagador gobierna el dron
     de fondo Y la afinacion. Aqui NO se inventa un momento nuevo del dron: fondoOn sigue siendo la variable
     interna que ya gobierna encender/apagar el dron; ademas ahora escala la afinacion. ON = dron + BASE_HZ =
     BASE_HZ_ORIGINAL * 432 / 440. OFF = sin dron + base original. Persistencia mp_japa_afinacion_v1 con la
     misma semantica del patron: '0' = apagado; ausente o cualquier otro valor = encendido. Se carga aqui,
     antes del primer sonido, para que BASE_HZ ya este afinado cuando nazca cualquier voz. */
  function cargarAfinacion() { try { return localStorage.getItem(LLAVE_AFINACION) !== '0'; } catch (e) { return true; } }
  function guardarAfinacion(on) { try { if (on) { localStorage.removeItem(LLAVE_AFINACION); } else { localStorage.setItem(LLAVE_AFINACION, '0'); } } catch (e) {} }
  fondoOn = cargarAfinacion();
  if (fondoOn) { BASE_HZ = BASE_HZ_ORIGINAL * 432 / 440; }
  /* observabilidad (BASE_HZ vive con var dentro de la IIFE): espejo de solo lectura para QA. Devuelve el
     valor vivo, nunca se queda viejo; no altera ninguna voz ni el toggle. */
  try { Object.defineProperty(window, 'BASE_HZ', { configurable: true, get: function () { return BASE_HZ; } }); } catch (e) { /* observabilidad opcional */ }

  /* ===================== la ruta de audio de iOS (injerto salidaDe, espejo del Oraculo) =====================
     En iPhone el switch fisico de silencio MUTEA el WebAudio puro (la salida maestra lp -> destination). La
     cura: enrutar esa salida maestra por un MediaStreamAudioDestinationNode a un <audio playsinline> oculto
     (iOS lo trata como medio y suena en silencio, como un video); ese elemento solo transporta el stream
     local, nunca red ni archivos. salidaDe(ac) devuelve ese destino SOLO en iOS; si algo falla (mediaRota),
     cae a ac.destination (red de seguridad: jamas peor que hoy). El singleton (el <audio> y su stream) nace
     DENTRO del gesto, en la primera voz. Desktop y Android: salidaDe devuelve ac.destination y jamas se crea
     un solo elemento de audio (esIOS false). */
  var esIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var mediaSalida = null;
  var mediaRota = false;
  var sesionAudio = false; /* parche gen (audio-sesion-ios): con la sesion de audio de Safari en playback, salida directa */
  function salidaDe(ac) {
    if (!esIOS || mediaRota || sesionAudio) { return ac.destination; }
    try {
      if (!mediaSalida) {
        var dest = ac.createMediaStreamDestination();
        var el = document.createElement('audio');
        el.setAttribute('playsinline', '');
        el.setAttribute('aria-hidden', 'true');
        el.style.position = 'absolute'; el.style.width = '0'; el.style.height = '0'; el.style.opacity = '0';
        el.srcObject = dest.stream;
        (document.querySelector('.app-shell') || document.documentElement).appendChild(el);
        mediaSalida = { dest: dest, el: el };
      }
      if (mediaSalida.el.paused) {
        var p = mediaSalida.el.play();
        if (p && p.catch) { p.catch(function () { mediaRota = true; }); }
      }
      return mediaSalida.dest;
    } catch (e) { mediaRota = true; return ac.destination; }
  }
  /* iOS interrumpe el audio en llamadas o Siri: al volver, reanuda el contexto y el elemento de medios. */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && sonidoOn && audioCtx) {
      try { if (audioCtx.state !== 'running' && audioCtx.resume) { audioCtx.resume().catch(function () {}); } } catch (e) {}
      if (mediaSalida && mediaSalida.el && mediaSalida.el.paused && !mediaRota) {
        try { var pp = mediaSalida.el.play(); if (pp && pp.catch) { pp.catch(function () {}); } } catch (e) {}
      }
    }
  });

  function ctxAudio() {
    if (!audioCtx) {
      /* parche gen (audio-sesion-ios): la sesion de Safari en playback suena con el switch en silencio sin el <audio> que se atoraba */
      try { if (navigator.audioSession) { navigator.audioSession.type = 'playback'; sesionAudio = navigator.audioSession.type === 'playback'; } } catch (e) { sesionAudio = false; }
      try { audioCtx = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { audioCtx = null; return null; }
      masterGain = audioCtx.createGain(); masterGain.gain.value = 0.66; // [PIEZA 1] más sutil: baja el volumen general
      var lp = audioCtx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 5200; // redondea el timbre (menos parcial agudo)
      reverbNode = audioCtx.createConvolver();
      var dur = 2.4, sr = audioCtx.sampleRate, buf = audioCtx.createBuffer(2, dur * sr, sr); // cola más larga: más aire
      for (var ch = 0; ch < 2; ch++) {
        var d = buf.getChannelData(ch);
        for (var i = 0; i < d.length; i++) { d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / d.length, 3.2); }
      }
      reverbNode.buffer = buf;
      var seco = audioCtx.createGain(); seco.gain.value = 0.70;
      var mojado = audioCtx.createGain(); mojado.gain.value = 0.36; // más reverberación: se siente más de lo que se oye
      masterGain.connect(seco).connect(lp);
      masterGain.connect(reverbNode); reverbNode.connect(mojado).connect(lp);
      lp.connect(salidaDe(audioCtx));
    }
    try {
      if (audioCtx.state !== 'running') { audioCtx.resume(); }
      if (!audioDespierto) {
        var b = audioCtx.createBuffer(1, 1, 22050), s = audioCtx.createBufferSource();
        s.buffer = b; s.connect(audioCtx.destination); s.start(0); audioDespierto = true;
      }
    } catch (e) { /* audio bloqueado en este entorno: la práctica sigue en silencio */ }
    return audioCtx;
  }

  function vMarimba(f, t) { // [PIEZA 1] la voz del japa recalibrada: honda, redonda, de ataque suave, más
    // sentida que oída. Gains más bajos, sin el parcial agudo (el 4º), una octava tenue por cuerpo, cola
    // más resonante y ataque lento. Cada partial = [múltiplo, gain, decaimiento, ataque].
    [[1, 0.16, 0.62, 0.018], [2, 0.028, 0.34, 0.026]].forEach(function (p) {
      var o = audioCtx.createOscillator(), g = audioCtx.createGain();
      o.frequency.value = f * p[0];
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(p[1], t + p[3]);
      g.gain.exponentialRampToValueAtTime(0.0001, t + p[2]);
      o.connect(g).connect(masterGain);
      o.start(t); o.stop(t + p[2] + 0.05);
    });
  }
  function vSub(f, t) { // golpe hondo del suelo (sellado)
    var o = audioCtx.createOscillator(), g = audioCtx.createGain();
    o.type = 'sine';
    o.frequency.setValueAtTime(f, t);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.22, t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.45);
    o.connect(g).connect(masterGain);
    o.start(t); o.stop(t + 0.5);
  }
  function latido(t) { // lub-dub sutil: el corazón de la casa recibe la vuelta a casa (sellado)
    [[0, 0.09, 150, 82], [0.16, 0.07, 135, 78]].forEach(function (p) {
      var o = audioCtx.createOscillator(), g = audioCtx.createGain();
      o.type = 'sine';
      o.frequency.setValueAtTime(p[2], t + p[0]);
      o.frequency.exponentialRampToValueAtTime(p[3], t + p[0] + p[1]);
      g.gain.setValueAtTime(0.0001, t + p[0]);
      g.gain.exponentialRampToValueAtTime(0.14, t + p[0] + 0.015);
      g.gain.exponentialRampToValueAtTime(0.0001, t + p[0] + p[1] + 0.05);
      o.connect(g).connect(masterGain);
      o.start(t + p[0]); o.stop(t + p[0] + p[1] + 0.1);
    });
    if (navigator.vibrate) { setTimeout(function () { try { navigator.vibrate([28, 90, 22]); } catch (e) {} }, 550); }
  }

  /* [PIEZA 5] el tono hondo y quedo de un marcador sagrado: fundamental grave + una quinta muy tenue que
     le da cuerpo de "cuenta especial". Suena a la vez que la voz normal, más abajo, sin taparla. */
  function vMarcador(mul, dur, t) {
    var f = BASE_HZ * mul;
    [[1, 0.085], [1.5, 0.03]].forEach(function (p) {
      var o = audioCtx.createOscillator(), g = audioCtx.createGain();
      o.type = 'sine';
      o.frequency.value = f * p[0];
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(p[1], t + 0.05);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(g).connect(masterGain);
      o.start(t); o.stop(t + dur + 0.05);
    });
  }
  function marcadorSuena(bead) { // nota honda + háptica distinta; nunca interrumpe la voz de la cuenta
    var voz = MARCADOR_VOZ[bead]; if (!voz) { return; }
    if (sonidoOn && audioCtx) { vMarcador(voz.mul, voz.dur, audioCtx.currentTime + 0.03); }
    vibrar(voz.vib);
  }

  /* la voz del japa: cada cuenta suena a la altura de su posición (base * 2^(cuenta/107)); subiendo
     asciende y cierra la octava en 108, de regreso desciende a casa; al voltear en el gurú, golpe
     hondo doble. Las subidas/bajadas de escala se conservan (pieza 1 del brief). */
  function golpeHondoDoble(t) { vSub(BASE_HZ / 2, t); vSub(BASE_HZ / 2, t + 0.14); }
  function sonarCuenta(bead, esVolteo) {
    if (!sonidoOn) { return; }
    var a = ctxAudio(); if (!a) { return; }
    var t = a.currentTime + 0.001;
    var f = BASE_HZ * Math.pow(2, bead / ULTIMA);
    vMarimba(f, t);
    if (esVolteo) { golpeHondoDoble(t + 0.02); }
  }

  /* el fondo grave sellado: dron una octava abajo, gain ~0.04 */
  function encenderFondo() {
    var a = ctxAudio(); if (!a || dronNodo) { return; }
    dronNodo = { o: a.createOscillator(), g: a.createGain() };
    dronNodo.o.frequency.value = BASE_HZ / 2;
    dronNodo.g.gain.value = 0.0001;
    dronNodo.o.connect(dronNodo.g).connect(masterGain);
    dronNodo.o.start();
    dronNodo.g.gain.exponentialRampToValueAtTime(0.04, a.currentTime + 1.2);
  }
  function apagarFondo() {
    if (!dronNodo || !audioCtx) { return; }
    dronNodo.g.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + 0.6);
    var d = dronNodo; dronNodo = null;
    setTimeout(function () { try { d.o.stop(); } catch (e) {} }, 800);
  }

  /* la respiración sincronizada al sonido. LA VOZ SELLADA POR SU OÍDO (4-jul): 'c' LA MAREA,
     "como si fuera el mar": ruido rosa por un lowpass cuyo brillo (cutoff) y volumen suben al inhalar
     y bajan hasta un piso AUDIBLE al exhalar (curva de coseno alzado, la forma S del aliento), sobre
     un suelo cálido (seno una octava abajo) con vaivén suave que da tierra.
     Descartadas que viven de referencia en el código (sin UI): 'a' la actual de la ronda 2 (dos senos,
     ganancia en rampas lineales), 'b' la ola (la marea sin suelo), 'd' el tono que sube (portamento).
     La interfaz externa (iniciarSwell / actualizarTonoSwell / detenerSwell) despacha por estado.vozRespira,
     forzado a 'c' en cargar(); cambiaVoz() queda de referencia. Todas las voces cuelgan del mismo
     masterGain (heredan la reverberación y el volumen). El apagador "Sonido" manda. */
  function tonoMul() { return 0.62 + (estado.tonoRespira / 100) * 0.9; } // grave (0.62) a agudo (1.52)

  /* [CURA · LA SOMBRA ANALITICA] jamas leer AudioParam.value (traicionero entre navegadores, Safari sobre
     todo): ahi nacia el brinco del turno inhala->exhala. Cada parametro automatizado de las voces b/c/d
     lleva una SOMBRA { v0, v1, t0, dur } de su ULTIMA curva programada. valorSombra la evalua con la MISMA
     matematica del coseno alzado que se le mando al motor: la sombra ES el valor real, terminada o en
     vuelo, sin preguntarle nada al navegador. */
  function nuevaSombra(v) { return { v0: v, v1: v, t0: 0, dur: 0.001 }; }
  function valorSombra(s, t) {
    var x = Math.max(0, Math.min(1, (t - s.t0) / s.dur));
    return s.v0 + (s.v1 - s.v0) * (0.5 - 0.5 * Math.cos(Math.PI * x));
  }
  // curva de coseno alzado (forma S del aliento) anclada por la sombra: arranca EXACTAMENTE donde la
  // sombra dice (objetivo alcanzado en el turno natural, o el valor en vuelo si se corta antes) y termina
  // en 'hasta'. setValueAtTime(desde) ahora + el arranque de la curva EN desde 20 ms despues = continuidad
  // por construccion, sin brinco. Al final actualiza la sombra a la curva recien mandada.
  function curvaHacia(param, sombra, hasta, ms) {
    if (!audioCtx) { return; }
    var ahora = audioCtx.currentTime;
    var desde = valorSombra(sombra, ahora);
    try { param.cancelScheduledValues(ahora); param.setValueAtTime(desde, ahora); } catch (e) {}
    var t0 = ahora + 0.02, dur = Math.max(0.05, ms / 1000), n = 48, arr = new Float32Array(n);
    for (var i = 0; i < n; i++) { var x = i / (n - 1); arr[i] = desde + (hasta - desde) * (0.5 - 0.5 * Math.cos(Math.PI * x)); }
    try { param.setValueCurveAtTime(arr, t0, dur); } catch (e) {}
    sombra.v0 = desde; sombra.v1 = hasta; sombra.t0 = t0; sombra.dur = dur;
  }
  // reencauza un param al vuelo (cambio de TONO) por la MISMA curvaHacia, curva corta: la sombra sigue siendo verdad
  function retarget(param, sombra, valor) { curvaHacia(param, sombra, valor, 300); }
  function nivelSon(x) { return sonidoOn ? x : 0.0001; } // el apagador "Sonido" al piso

  // el buffer de la ola: ruido rosa (Paul Kellet) en loop SIN COSTURA por EMPALME CRUZADO a potencia
  // constante. Antes desvanecia los bordes a cero (50 ms): eso creaba un BAJON del aire cada 3.5 s (el
  // entrecorte). Ahora genero N+M muestras y el buffer final de largo N cruza sus primeras M muestras
  // con las que vienen JUSTO despues del punto de loop: y[N-1] = x[N-1] y y[0] = x[N] son muestras
  // CONSECUTIVAS del mismo ruido, asi el empalme es continuo, y el crossfade de M esconde el salto del
  // estado de los filtros rosa. Cero desvanecimientos a cero: el mar nunca calla.
  function bufferRuido() {
    var sr = audioCtx.sampleRate, N = Math.floor(sr * 3.5), M = Math.floor(sr * 0.35);
    var x = new Float32Array(N + M);
    var b0 = 0, b1 = 0, b2 = 0, b3 = 0, b4 = 0, b5 = 0, b6 = 0;
    for (var i = 0; i < N + M; i++) {
      var w = Math.random() * 2 - 1;
      b0 = 0.99886 * b0 + w * 0.0555179; b1 = 0.99332 * b1 + w * 0.0750759; b2 = 0.96900 * b2 + w * 0.1538520;
      b3 = 0.86650 * b3 + w * 0.3104856; b4 = 0.55000 * b4 + w * 0.5329522; b5 = -0.7616 * b5 - w * 0.0168980;
      x[i] = (b0 + b1 + b2 + b3 + b4 + b5 + b6 + w * 0.5362) * 0.11;
      b6 = w * 0.115926;
    }
    var buf = audioCtx.createBuffer(1, N, sr), y = buf.getChannelData(0);
    for (var j = 0; j < N; j++) {
      if (j < M) { var wc = j / M; y[j] = x[j] * Math.sin(wc * Math.PI / 2) + x[N + j] * Math.cos(wc * Math.PI / 2); }
      else { y[j] = x[j]; }
    }
    return buf;
  }

  // ---- construcción de cada voz (todas dejan swellNodo con voz + ganancias + fuentes + nodos + mul) ----
  function iniciarSwellA(a) { // 'a' la actual: idéntica a la ronda 1 (referencia)
    var g = a.createGain(); g.gain.value = 0.0001;
    var base = BASE_HZ * tonoMul();
    var o1 = a.createOscillator(); o1.type = 'sine'; o1.frequency.value = base;
    var o2 = a.createOscillator(); o2.type = 'sine'; o2.frequency.value = base * 1.5; // la quinta, aire
    try { o2.detune.value = 4; } catch (e) {}
    o1.connect(g); o2.connect(g); g.connect(masterGain);
    o1.start(); o2.start();
    swellNodo = { voz: 'a', g: g, o1: o1, o2: o2, mul: tonoMul(), ganancias: [g.gain], fuentes: [o1, o2], nodos: [o1, o2, g] };
  }
  function iniciarSwellRuido(a, conSuelo) { // 'b' la ola, y 'c' la marea (ola + suelo)
    var mul = tonoMul();
    var fuente = a.createBufferSource(); fuente.buffer = bufferRuido(); fuente.loop = true;
    var filtro = a.createBiquadFilter(); filtro.type = 'lowpass'; filtro.Q.value = 0.9; filtro.frequency.value = 140 * mul;
    var g = a.createGain(); g.gain.value = 0.0001; // arranca en silencio; la primera inhalación sube sin chasquido (piso de exhalación audible = 0.014)
    fuente.connect(filtro).connect(g).connect(masterGain);
    fuente.start();
    var s = { voz: conSuelo ? 'c' : 'b', filtro: filtro, g: g, mul: mul };
    s.sFiltro = nuevaSombra(140 * mul); // sombra del brillo del filtro (nace en su piso de exhalación)
    s.sG = nuevaSombra(0.0001);         // sombra de la ganancia de la ola (nace en silencio)
    var nodos = [fuente, filtro, g], fuentes = [fuente], ganSombras = [{ p: g.gain, s: s.sG }];
    if (conSuelo) {
      var suelo = a.createOscillator(); suelo.type = 'sine'; suelo.frequency.value = BASE_HZ_ORIGINAL * mul * 0.5; // una octava abajo (base sellada: LA MAREA no sigue al chip 432)
      var sg = a.createGain(); sg.gain.value = 0.0001; // arranca en silencio; suelo cálido ~0.010 con vaivén +/- 35%
      suelo.connect(sg).connect(masterGain); suelo.start();
      s.suelo = suelo; s.sueloG = sg;
      s.sSueloF = nuevaSombra(BASE_HZ_ORIGINAL * mul * 0.5); // sombra de la base del suelo (solo la mueve el TONO; base sellada, ajena al chip 432)
      s.sSueloG = nuevaSombra(0.0001);              // sombra del vaivén del suelo
      nodos.push(suelo, sg); fuentes.push(suelo); ganSombras.push({ p: sg.gain, s: s.sSueloG });
    }
    s.ganSombras = ganSombras; s.fuentes = fuentes; s.nodos = nodos;
    swellNodo = s;
  }
  function iniciarSwellD(a) { // 'd' el tono que sube: base + octava abajo a mitad, sin ruido
    var mul = tonoMul();
    var g = a.createGain(); g.gain.value = 0.0001; // arranca en silencio; piso de exhalación audible = 0.014
    var oBase = a.createOscillator(); oBase.type = 'sine'; oBase.frequency.value = BASE_HZ * mul;
    var oOct = a.createOscillator(); oOct.type = 'sine'; oOct.frequency.value = BASE_HZ * mul * 0.5;
    var gOct = a.createGain(); gOct.gain.value = 0.5; // la octava a mitad de ganancia, fija
    oBase.connect(g); oOct.connect(gOct).connect(g); g.connect(masterGain);
    oBase.start(); oOct.start();
    var s = { voz: 'd', g: g, oBase: oBase, oOct: oOct, mul: mul };
    s.sG = nuevaSombra(0.0001);              // sombra de la ganancia (nace en silencio)
    s.sOBase = nuevaSombra(BASE_HZ * mul);   // sombra de la frecuencia base
    s.sOOct = nuevaSombra(BASE_HZ * mul * 0.5); // sombra de la octava abajo
    s.ganSombras = [{ p: g.gain, s: s.sG }]; s.fuentes = [oBase, oOct]; s.nodos = [oBase, oOct, gOct, g];
    swellNodo = s;
  }
  function iniciarSwell() {
    var a = ctxAudio(); if (!a || swellNodo) { return; }
    var voz = estado.vozRespira;
    if (voz === 'a') { iniciarSwellA(a); }
    else if (voz === 'b') { iniciarSwellRuido(a, false); }
    else if (voz === 'd') { iniciarSwellD(a); }
    else { iniciarSwellRuido(a, true); } // 'c' default
  }

  // el TONO (0-100) mueve las 4 voces al vuelo
  function actualizarTonoSwell() {
    if (!swellNodo || !audioCtx) { return; }
    var nuevo = tonoMul();
    try {
      if (swellNodo.voz === 'a') {
        var base = BASE_HZ * nuevo;
        swellNodo.o1.frequency.setTargetAtTime(base, audioCtx.currentTime, 0.15);
        swellNodo.o2.frequency.setTargetAtTime(base * 1.5, audioCtx.currentTime, 0.15);
      } else {
        var ahora = audioCtx.currentTime, s = swellNodo, ratio = nuevo / (s.mul || nuevo);
        if (s.filtro) { retarget(s.filtro.frequency, s.sFiltro, valorSombra(s.sFiltro, ahora) * ratio); } // b y c: el rango del filtro
        if (s.suelo) { retarget(s.suelo.frequency, s.sSueloF, BASE_HZ_ORIGINAL * nuevo * 0.5); }           // c: la base del suelo (sellada, ajena al chip 432)
        if (s.oBase) { retarget(s.oBase.frequency, s.sOBase, valorSombra(s.sOBase, ahora) * ratio); }      // d: los senos
        if (s.oOct) { retarget(s.oOct.frequency, s.sOOct, valorSombra(s.sOOct, ahora) * ratio); }
      }
      swellNodo.mul = nuevo;
    } catch (e) {}
  }

  // el paso de la respiración dibuja el aliento con curva de coseno; despacha por voz
  function faseSwell(fase, ms) {
    if (!swellNodo || !audioCtx) { return; }
    var inhala = (fase === 'inhala'), s = swellNodo, mul = s.mul || tonoMul();
    if (s.voz === 'a') { swellHacia(inhala ? 0.05 : 0.004, ms); return; } // referencia: rampas lineales exactas
    if (s.voz === 'b' || s.voz === 'c') {
      curvaHacia(s.filtro.frequency, s.sFiltro, (inhala ? 750 : 140) * mul, ms);       // el brillo dibuja el aliento
      curvaHacia(s.g.gain, s.sG, nivelSon(inhala ? 0.050 : 0.014), ms);               // el volumen, como una ola lenta
      if (s.sueloG) { curvaHacia(s.sueloG.gain, s.sSueloG, nivelSon(inhala ? 0.0135 : 0.0065), ms); } // c: el vaivén del suelo (+/- 35%)
      return;
    }
    // 'd': el tono se desliza una tercera menor (x1.19) y la ganancia sube en S
    curvaHacia(s.oBase.frequency, s.sOBase, BASE_HZ * mul * (inhala ? 1.19 : 1), ms);
    curvaHacia(s.oOct.frequency, s.sOOct, BASE_HZ * mul * 0.5 * (inhala ? 1.19 : 1), ms);
    curvaHacia(s.g.gain, s.sG, nivelSon(inhala ? 0.045 : 0.014), ms);
  }

  // baja TODAS las ganancias de la voz al piso (apagador "Sonido", fin de respiración): sin cortar los nodos
  function silenciaSwell(ms) {
    if (!swellNodo || !audioCtx) { return; }
    var s = swellNodo;
    if (s.voz === 'a') { // referencia SELLADA: rampa lineal desde el valor vivo, idéntica a la ronda 1
      var t = audioCtx.currentTime;
      s.ganancias.forEach(function (p) {
        try { p.cancelScheduledValues(t); p.setValueAtTime(Math.max(0.0001, p.value), t); p.linearRampToValueAtTime(0.0001, t + ms / 1000); } catch (e) {}
      });
      return;
    }
    // b/c/d: al piso por la MISMA curvaHacia, sombras honestas (arranca del valorSombra, sin leer .value)
    s.ganSombras.forEach(function (par) { curvaHacia(par.p, par.s, 0.0001, ms); });
  }

  function detenerSwell() {
    if (!swellNodo || !audioCtx) { return; }
    var s = swellNodo; swellNodo = null;
    var t = audioCtx.currentTime;
    if (s.voz === 'a') { // referencia: piso instantáneo y stop, idéntico a la ronda 1
      try { s.g.gain.cancelScheduledValues(t); s.g.gain.setValueAtTime(0.0001, t); } catch (e) {}
    } else {
      // fundido corto que ARRANCA del valorSombra (no de param.value): los nodos y sus sombras mueren juntos
      s.ganSombras.forEach(function (par) {
        try { par.p.cancelScheduledValues(t); par.p.setValueAtTime(valorSombra(par.s, t), t); par.p.setTargetAtTime(0.0001, t, 0.08); } catch (e) {}
      });
    }
    setTimeout(function () {
      s.fuentes.forEach(function (n) { try { n.stop(); } catch (e) {} });
      s.nodos.forEach(function (n) { try { n.disconnect(); } catch (e) {} });
    }, 260);
  }

  // 'a' la actual usa rampas lineales de ganancia (referencia intacta); faseSwell la invoca para esa voz
  function swellHacia(nivel, ms) {
    if (!swellNodo || !audioCtx || swellNodo.voz !== 'a') { return; }
    if (!sonidoOn) { nivel = 0.0001; }
    var g = swellNodo.g.gain;
    try {
      g.cancelScheduledValues(audioCtx.currentTime);
      g.setValueAtTime(Math.max(0.0001, g.value), audioCtx.currentTime);
      g.linearRampToValueAtTime(Math.max(0.0001, nivel), audioCtx.currentTime + ms / 1000);
    } catch (e) {}
  }

  // el cambio de voz en vivo: funde limpio, sin cortar el ciclo visual ni el conteo
  function cambiaVoz(v) {
    if (['a', 'b', 'c', 'd'].indexOf(v) < 0 || v === estado.vozRespira) { return; }
    estado.vozRespira = v; guardar(); pintarVoces();
    if (swellNodo) {
      detenerSwell();               // funde y libera la voz anterior (nodos se cortan tras ~260ms)
      iniciarSwell();               // arma la nueva en su piso
      faseSwell(respiraFase, 600);  // la asienta suave en la fase actual, sin clic ni interrupción del ciclo
    }
  }

  /* háptica sellada + mejora progresiva iOS por el switch nativo del label */
  function vibrar(patron) { if (navigator.vibrate) { try { navigator.vibrate(patron); } catch (e) {} } }
  function tickExtra(veces) {
    if (navigator.vibrate) { return; }
    var h = document.getElementById('hap');
    if (!h) { return; }
    for (var i = 1; i <= veces; i++) { setTimeout(function () { try { h.click(); } catch (e) {} }, 140 * i); }
  }

  /* Wake Lock sellado */
  function pedirDespertar() {
    if (wakeLock || !navigator.wakeLock) { return; }
    navigator.wakeLock.request('screen').then(function (w) {
      wakeLock = w; w.addEventListener('release', function () { wakeLock = null; });
    }).catch(function () {});
  }
  function liberarWakeLock() { if (wakeLock) { try { wakeLock.release(); } catch (e) {} } }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      if (sesionActiva) { wakeLock = null; pedirDespertar(); }
      if (estado.modo === 'respiracion') { arrancaRespira(); }
    } else { detieneRespira(); }
  });

  /* ===================== referencias del DOM ===================== */
  var elCara = document.getElementById('cara-practica');
  var elAltar = document.getElementById('altar');
  var elCuentaN = document.getElementById('cuenta-n');
  var elGuia = document.getElementById('japa-guia');
  var elGuru = document.getElementById('guru');
  var elSentido = document.getElementById('sentido');
  var elSentidoTexto = document.getElementById('sentido-texto');
  var elMantraTexto = document.getElementById('mantra-texto');
  var elMantraEsencia = document.getElementById('mantra-esencia');
  var elRespiraCirculo = document.getElementById('respira-circulo');
  var elRespiraFase = document.getElementById('respira-fase');
  var elPvTotal = document.getElementById('pv-total');
  var elPvHoy = document.getElementById('pv-hoy');
  var elPildora = document.getElementById('pildora-vueltas');
  var elReinicia = document.getElementById('japa-reinicia');
  var elChipSonido = document.getElementById('chip-sonido');
  var elChipFondo = document.getElementById('chip-fondo');
  var elChipMarcadores = document.getElementById('chip-marcadores');
  var elChipAuto = document.getElementById('chip-auto');
  var elChipMantras = document.getElementById('chip-mantras');
  var elBtnModoMantra = document.getElementById('btn-modo-mantra');
  var elBtnModoRespira = document.getElementById('btn-modo-respiracion');
  var elCtrlRitmo = document.getElementById('ctrl-ritmo');
  var elRitmoLbl = document.getElementById('ritmo-lbl');
  var elVozChips = document.getElementById('voz-chips');
  var elMarcaLinea = document.getElementById('marca-linea');
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /* ===================== el mantra al centro (estilo Aliento) ===================== */
  function pintarMantraCentro() {
    var m = mantraPorId(estado.mantraId);
    if (m.id === 'libre') {
      // Solo contar: el centro queda vacio y sereno (sin texto, sin esencia); la pildora dice "Solo contar".
      elMantraTexto.textContent = '';
      elMantraTexto.className = 'mantra-texto mantra--corto';
      elMantraEsencia.textContent = '';
      elChipMantras.querySelector('#chip-mantras-nombre').textContent = 'Solo contar';
      ajustarMantraAlAnillo();   // con texto vacio: resetea estilos y sale sin encoger (sin NaN ni caja rota)
      return;
    }
    if (m.largo) {
      // los dos mantras hondos: al centro solo su nombre de casa + primera línea
      elMantraTexto.textContent = m.nombre;
      elMantraTexto.className = 'mantra-texto mantra--medio';
      elMantraEsencia.textContent = m.linea1;
    } else {
      elMantraTexto.textContent = m.texto;
      elMantraTexto.className = 'mantra-texto mantra--' + m.clase;
      elMantraEsencia.textContent = m.esencia;
    }
    elChipMantras.querySelector('#chip-mantras-nombre').textContent = m.largo ? m.nombre : m.texto;
    ajustarMantraAlAnillo();
  }

  /* ===================== BUG 1 · el mantra cabe dentro del anillo (fit-to-box por medida real) =====================
     Los mantras largos (Tayata Om Bekanze..., el saludo de 13 palabras) desbordaban el anillo y se encimaban
     sobre la esencia ("linea de sentido") y sobre el contador. Aqui se define una caja segura centrada en el
     anillo (62% del diametro de ancho, 55% de alto, derivada de la medida real de .anillo-visual) y se ajusta
     el font-size del bloque por busqueda binaria entre su tamano natural (el clamp de su clase) y ~15px, hasta
     que el bloque COMPLETO (texto + esencia) cabe en alto. Nunca trunca ni elipsa (texto sagrado: entra
     completo, mas chico). El ancho se encierra en la caja para envolver dentro de ella. Como se mide el bloque
     entero y este queda dentro del 55% central del anillo, jamas se encima con la esencia ni con el contador
     (que vive debajo del anillo). Los mantras que ya caben quedan EXACTOS como hoy (solo encoge, jamas agranda).
     Recalcula al cambiar de mantra y en resize/orientationchange; cachea por (mantra, ancho de caja). */
  var ANCLA_MANTRA = { id: null, ancho: -1 };
  function ajustarMantraAlAnillo() {
    if (!elMantraTexto || !elVisual || !elCara) { return; }
    if (elCara.classList.contains('modo-respiracion')) { return; }   // en respiracion el centro no muestra el mantra
    var d = elVisual.getBoundingClientRect().width;
    if (d < 60) { return; }                                          // el anillo aun no es medible
    var boxW = Math.round(d * 0.62);
    var boxH = d * 0.55;
    if (ANCLA_MANTRA.id === estado.mantraId && Math.abs(ANCLA_MANTRA.ancho - boxW) < 1) { return; }
    ANCLA_MANTRA.id = estado.mantraId; ANCLA_MANTRA.ancho = boxW;
    var bloque = elMantraTexto.parentElement;                        // .centro-mala (texto + esencia)
    var LH = 1.12;
    // 1) medir a tamano y ancho naturales (como hoy): si el bloque ya cabe en alto, no se toca nada.
    elMantraTexto.style.maxWidth = '';
    elMantraTexto.style.fontSize = '';
    elMantraTexto.style.lineHeight = '';
    if (bloque.getBoundingClientRect().height <= boxH + 0.5) { return; }
    // 2) no cabe: envolver dentro de la caja (62%) y buscar el mayor tamano cuyo bloque cabe en alto (55%).
    var natural = parseFloat(window.getComputedStyle(elMantraTexto).fontSize) || 18;
    elMantraTexto.style.maxWidth = boxW + 'px';
    function cabe(fs) {
      elMantraTexto.style.fontSize = fs + 'px';
      elMantraTexto.style.lineHeight = LH;
      return bloque.getBoundingClientRect().height <= boxH + 0.5;
    }
    if (cabe(natural)) { return; }                                  // al envolver en 62% ya cabe: sin encoger
    var lo = 15, hi = natural, best = 15;                            // piso preferente 15px
    for (var it = 0; it < 20; it++) {
      var mid = (lo + hi) / 2;
      if (cabe(mid)) { best = mid; lo = mid; } else { hi = mid; }
    }
    elMantraTexto.style.fontSize = best + 'px';
    elMantraTexto.style.lineHeight = LH;
    // seguro por medida real: si el bloque aun toca el contador (anillo diminuto en pantallas muy
    // cortas, donde ni a 15px cabria), encoge SOLO lo justo (hasta 11px) para despegarse del contador.
    // Jamas trunca: el texto sagrado entra completo, un poco mas chico que el piso preferente.
    var margenContador = 4;
    for (var g = 0; g < 8 && best > 11; g++) {
      if (elMantraEsencia.getBoundingClientRect().bottom <= elCuentaN.getBoundingClientRect().top - margenContador) { break; }
      best = Math.max(11, best - 1);
      elMantraTexto.style.fontSize = best + 'px';
      elMantraTexto.style.lineHeight = LH;
    }
  }
  var _ajusteRAF = 0;
  function reajustaMantra() {
    ANCLA_MANTRA.id = null;                                         // fuerza recalculo tras el cambio de medida
    if (_ajusteRAF) { return; }
    _ajusteRAF = window.requestAnimationFrame(function () { _ajusteRAF = 0; ajustarMantraAlAnillo(); });
  }
  window.addEventListener('resize', reajustaMantra);
  window.addEventListener('orientationchange', reajustaMantra);

  /* ===================== render ===================== */
  function numeroPasada() {
    if (enCima) { return TOTAL; }
    return (estado.sentido > 0) ? (estado.cuenta + 1) : (TOTAL - estado.cuenta);
  }
  function textoGuia() {
    if (estado.modo === 'respiracion') {
      if (estado.modoAuto) { return 'El círculo respira y cuenta solo. Cierra los ojos: guíate por el sonido.'; }
      return 'Deja que el círculo respire por ti. El sonido guía; el toque acompaña.';
    }
    if (!empezado) { return 'Toda esta zona es la mala: tócala a tu ritmo. Una cuenta por cada repetición.'; }
    if (enCima) { return 'La mala se voltea: sigue del otro lado, el gurú nunca se cruza.'; }
    if (estado.sentido > 0) {
      if (estado.cuenta >= ULTIMA - 2) { return 'Al llegar al gurú, la mala se voltea: el umbral nunca se cruza.'; }
      return 'Una cuenta, una repetición. Sube hacia el gurú.';
    }
    if (estado.cuenta <= 2) { return 'Casi en casa. Al tocar el gurú, la mala vuelve a girar.'; }
    return 'De regreso a casa, cuenta por cuenta.';
  }
  function pintar() {
    pintarRueda();
    elCuentaN.textContent = empezado ? numeroPasada() : 0;
    var baja = estado.sentido < 0;
    elSentido.className = 'sentido ' + (baja ? 'baja' : 'sube');
    elSentidoTexto.textContent = baja ? 'de regreso' : 'subiendo';
    elGuia.textContent = textoGuia();
    elPvTotal.textContent = estado.vueltas;
    elPvHoy.textContent = vueltasHoy();
    elReinicia.classList.toggle('reinicia-oculta', !empezado && estado.cuenta === 0);
    pintarMantraCentro();
    aplicaAtmosfera();
  }

  function celebrarVolteo() {
    elGuru.classList.remove('mp-umbral'); void elGuru.offsetWidth; elGuru.classList.add('mp-umbral');
    window.setTimeout(function () { elGuru.classList.remove('mp-umbral'); }, 900);
    elCara.classList.add('mp-volteo');
    window.setTimeout(function () { elCara.classList.remove('mp-volteo'); }, 700);
    if (!mqReduce.matches) {
      elVisual.classList.remove('mp-volteando'); void elVisual.offsetWidth; elVisual.classList.add('mp-volteando');
      window.setTimeout(function () { elVisual.classList.remove('mp-volteando'); }, 820);
    }
  }

  /* ===================== el toque (mecánica sellada de la ronda 1) ===================== */
  function despertarSesion() {
    sesionActiva = true;
    pedirDespertar();
    if (!fondoAutoDisparado && fondoOn) { encenderFondo(); fondoAutoDisparado = true; }
  }
  function toque() {
    despertarSesion();
    ctxAudio();

    if (estado.modo === 'mantra' && !mqReduce.matches) {
      elMantraTexto.classList.remove('mp-recita'); void elMantraTexto.offsetWidth; elMantraTexto.classList.add('mp-recita');
    }

    if (!empezado) {
      empezado = true;
      estado.cuenta = 0; estado.sentido = 1; enCima = false;
      sonarCuenta(0, false); vibrar(10); destellarCuenta(0);
      guardar(); pintar();
      return;
    }
    if (enCima) {
      enCima = false;
      sonarCuenta(estado.cuenta, false);
      destellarCuenta(estado.cuenta);
      vibrar(10);
      guardar(); pintar();
      return;
    }
    var s = estado.sentido;
    estado.cuenta += (s > 0) ? 1 : -1;
    var llegoAlGuru = (s > 0 && estado.cuenta === ULTIMA) || (s < 0 && estado.cuenta === 0);
    if (llegoAlGuru) {
      enCima = true;
      estado.sentido = -s;
      sonarCuenta(estado.cuenta, true);
      destellarCuenta(estado.cuenta);
      vibrar([45, 90, 45, 90, 160]); tickExtra(2);
      registrarVuelta();
      celebrarVolteo();
      if (s < 0 && sonidoOn && audioCtx) { latido(audioCtx.currentTime + 0.55); }
      // el hito llega SIEMPRE al cerrar la ceremonia del volteo: se agenda con la espera justa para
      // que el destello del guru se apague antes de que suba el momento dorado, mas quieto.
      if (hitoPendiente) {
        var vHito = hitoPendiente; hitoPendiente = 0;
        var esperaHito = mqReduce.matches ? 700 : 1150; // la ceremonia dura ~900 ms; el hito entra despues
        hitoTimer = window.setTimeout(function () { revelaHito(vHito, true); }, esperaHito);
      }
    } else {
      sonarCuenta(estado.cuenta, false);
      destellarCuenta(estado.cuenta);
      if (estado.marcadoresOn && MARCADOR_VOZ[estado.cuenta]) { marcadorSuena(estado.cuenta); } // [PIEZA 5]
      else { vibrar(10); }
    }
    guardar(); pintar();
  }
  elAltar.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'hap') { return; }
    toque();
  });
  elAltar.addEventListener('keydown', function (e) {
    if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toque(); }
  });

  /* ===================== la respiración: círculo que respira + swell sincronizado =====================
     El ciclo lo fija RITMO (estado.ritmoCiclo, 6 a 14 s); inhala ~45%, exhala ~55%. En modo AUTOMÁTICO
     (propuesta), cada ciclo completo avanza una cuenta sin tocar la pantalla: "solo guiándote por el
     sonido". [GANCHO OLA 2] la ola 2 refina la finura del automático y su acople al ascenso. */
  var respiraTimer = null, respiraActiva = false, respiraFase = 'inhala';
  function tiempos() {
    var total = estado.ritmoCiclo * 1000;
    return { ti: Math.round(total * 0.45), te: Math.round(total * 0.55) };
  }
  function pasoRespira(fase) {
    respiraFase = fase;
    var t = tiempos();
    if (fase === 'inhala') {
      if (elRespiraCirculo) {
        elRespiraCirculo.style.transitionDuration = t.ti + 'ms';
        if (mqReduce.matches) { elRespiraCirculo.style.opacity = '0.95'; }
        else { elRespiraCirculo.style.transform = 'translate(-50%, -50%) scale(1.16)'; }
      }
      if (elRespiraFase) { elRespiraFase.textContent = 'inhala'; elRespiraFase.style.opacity = '0.85'; }
      faseSwell('inhala', t.ti);
      respiraTimer = window.setTimeout(function () { pasoRespira('exhala'); }, t.ti);
    } else {
      if (elRespiraCirculo) {
        elRespiraCirculo.style.transitionDuration = t.te + 'ms';
        if (mqReduce.matches) { elRespiraCirculo.style.opacity = '0.5'; }
        else { elRespiraCirculo.style.transform = 'translate(-50%, -50%) scale(0.82)'; }
      }
      if (elRespiraFase) { elRespiraFase.textContent = 'exhala'; elRespiraFase.style.opacity = '0.55'; }
      faseSwell('exhala', t.te);
      respiraTimer = window.setTimeout(function () {
        // el modo automático (propuesta): al cerrar el ciclo, avanza una cuenta sola
        if (estado.modoAuto && estado.modo === 'respiracion') { toque(); }
        pasoRespira('inhala');
      }, t.te);
    }
  }
  function arrancaRespira() {
    if (estado.modo !== 'respiracion') { return; }
    if (respiraActiva) { return; }
    respiraActiva = true;
    if (audioCtx && sesionActiva) { iniciarSwell(); }
    pasoRespira('inhala');
  }
  function detieneRespira() {
    respiraActiva = false;
    if (respiraTimer) { window.clearTimeout(respiraTimer); respiraTimer = null; }
    if (elRespiraCirculo) { elRespiraCirculo.style.transitionDuration = '600ms'; elRespiraCirculo.style.transform = 'translate(-50%, -50%) scale(1)'; elRespiraCirculo.style.opacity = ''; }
    silenciaSwell(400);
  }

  /* ===================== los modos ===================== */
  function aplicaModo() {
    var esResp = (estado.modo === 'respiracion');
    elCara.classList.toggle('modo-respiracion', esResp);
    elCara.classList.toggle('modo-mantra', !esResp);
    elBtnModoMantra.classList.toggle('activo', !esResp);
    elBtnModoMantra.setAttribute('aria-pressed', String(!esResp));
    elBtnModoRespira.classList.toggle('activo', esResp);
    elBtnModoRespira.setAttribute('aria-pressed', String(esResp));
    if (esResp) { arrancaRespira(); } else { detieneRespira(); detenerSwell(); pintarMantraCentro(); }
    elGuia.textContent = textoGuia();
  }
  elBtnModoMantra.addEventListener('click', function () { if (estado.modo === 'mantra') { return; } estado.modo = 'mantra'; guardar(); aplicaModo(); });
  elBtnModoRespira.addEventListener('click', function () {
    if (estado.modo === 'respiracion') { return; }
    estado.modo = 'respiracion'; guardar();
    despertarSesion(); ctxAudio();   // el toque es un gesto: desde ya se oye el aliento sincronizado
    aplicaModo();
  });

  /* ===================== apagadores y controles ===================== */
  elChipSonido.addEventListener('click', function () {
    sonidoOn = !sonidoOn;
    this.classList.toggle('activo', sonidoOn);
    this.setAttribute('aria-pressed', String(sonidoOn));
    if (!sonidoOn) { silenciaSwell(300); }
  });
  elChipFondo.addEventListener('click', function () {
    fondoOn = !fondoOn;
    this.classList.toggle('activo', fondoOn);
    this.setAttribute('aria-pressed', String(fondoOn));
    BASE_HZ = fondoOn ? (BASE_HZ_ORIGINAL * 432 / 440) : BASE_HZ_ORIGINAL; // el chip 432 escala toda la afinacion; LA MAREA queda sellada
    guardarAfinacion(fondoOn);
    if (!fondoOn) { apagarFondo(); fondoAutoDisparado = false; }
    else if (sesionActiva) { encenderFondo(); fondoAutoDisparado = true; } // dron nace ya afinado sobre el nuevo BASE_HZ
  });
  elChipMarcadores.addEventListener('click', function () {
    estado.marcadoresOn = !estado.marcadoresOn;
    this.classList.toggle('activo', estado.marcadoresOn);
    this.setAttribute('aria-pressed', String(estado.marcadoresOn));
    elVisual.classList.toggle('marcadores-off', !estado.marcadoresOn);
    guardar();
  });
  elChipAuto.addEventListener('click', function () {
    estado.modoAuto = !estado.modoAuto;
    this.classList.toggle('activo', estado.modoAuto);
    this.setAttribute('aria-pressed', String(estado.modoAuto));
    elMarcaLinea.textContent = estado.modoAuto ? 'modo automático · el círculo respira y cuenta solo (propuesta)' : '';
    if (estado.modoAuto) {
      despertarSesion(); ctxAudio();
      if (!respiraActiva) { arrancaRespira(); } else if (!swellNodo) { iniciarSwell(); }
    }
    elGuia.textContent = textoGuia();
    guardar();
  });

  function aplicaRitmoLbl() { elRitmoLbl.textContent = estado.ritmoCiclo + ' s'; }
  elCtrlRitmo.addEventListener('input', function () {
    estado.ritmoCiclo = Math.min(14, Math.max(6, this.value | 0));
    aplicaRitmoLbl(); guardar();
    // el ciclo nuevo entra en el siguiente paso; el reloj vivo no se corta con brusquedad
  });
  /* el slider de TONO se retiro (4-jul, palabra del fundador: "con el sonido del mar ya no es
     necesario modificar el tono"); tonoRespira queda sellado en 50 y actualizarTonoSwell vive
     de referencia por si el tono volviera a ser ajustable algun dia. */

  /* la elección de voz de la respiración: 4 chips en el piso (fuera del altar, no cuentan como toque).
     Cambia la voz en vivo, sin cortar el ciclo visual ni el conteo; persiste en estado. */
  function pintarVoces() {
    if (!elVozChips) { return; }
    var bs = elVozChips.querySelectorAll('.voz-chip');
    for (var i = 0; i < bs.length; i++) { bs[i].setAttribute('aria-pressed', String(bs[i].getAttribute('data-voz') === estado.vozRespira)); }
  }
  if (elVozChips) {
    elVozChips.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.voz-chip') : null;
      if (!b) { return; }
      cambiaVoz(b.getAttribute('data-voz'));
    });
  }

  elReinicia.addEventListener('click', function () {
    estado.cuenta = 0; estado.sentido = 1; empezado = false; enCima = false;
    vibrar([20, 80, 20]);
    liberarWakeLock(); sesionActiva = false;
    guardar(); pintar();
  });

  /* ===================== navegación entre caras ===================== */
  var elCaraMantras = document.getElementById('cara-mantras');
  var elCaraDetalle = document.getElementById('cara-detalle');
  function mostrarCara(cual) {
    [['cara-practica', elCara], ['cara-mantras', elCaraMantras], ['cara-detalle', elCaraDetalle]].forEach(function (par) {
      var activa = (par[0] === cual);
      par[1].classList.toggle('cara-activa', activa);
      par[1].setAttribute('aria-hidden', String(!activa));
    });
    // Si pintar() corrió con la cara de práctica oculta (elegir mantra desde la lista o desde la
    // ceremonia), el anillo midió 0 y el ajuste del mantra abortó sin aplicarse. Aquí la cara ya es
    // visible y medible: se re-ajusta. Si nada cambió, el caché lo vuelve gratis.
    if (cual === 'cara-practica') { ajustarMantraAlAnillo(); }
  }
  elChipMantras.addEventListener('click', function () { construirLista(); mostrarCara('cara-mantras'); });
  document.getElementById('mantras-atras').addEventListener('click', function () { mostrarCara('cara-practica'); });
  document.getElementById('detalle-atras').addEventListener('click', function () { mostrarCara('cara-mantras'); });

  /* ===================== la pantalla de mantras (acordeón por categoría) ===================== */
  var elLista = document.getElementById('mantras-lista');
  var catAbierta = -1;
  function catDelMantra(id) { return mantraPorId(id).cat; }
  function elegirSoloContar() {
    // Solo contar: selecciona directo (sin detalle) y regresa a la practica, como la seleccion normal.
    estado.mantraId = 'libre';
    if (estado.modo === 'respiracion') { estado.modo = 'mantra'; }
    guardar();
    aplicaModo();
    pintar();
    mostrarCara('cara-practica');
  }
  function construirLista() {
    if (catAbierta < 0) { catAbierta = catDelMantra(estado.mantraId); }
    elLista.innerHTML = '';
    // "Solo contar" · antes de las categorias, la version mas minimalista: la vuelta sin mantra. No abre
    // detalle (no hay fonetica que ver): selecciona directo. Se marca es-elegido cuando el modo libre esta activo.
    var solo = document.createElement('button');
    solo.type = 'button';
    solo.className = 'solo-contar' + (estado.mantraId === 'libre' ? ' es-elegido' : '');
    var soloInfo = document.createElement('span');
    soloInfo.innerHTML = '<span class="mf-nombre"></span><span class="mf-texto"></span>';
    soloInfo.querySelector('.mf-nombre').textContent = 'Solo contar';
    soloInfo.querySelector('.mf-texto').textContent = 'La vuelta, sin mantra.';
    var soloPunto = document.createElement('span'); soloPunto.className = 'mf-punto';
    solo.appendChild(soloInfo); solo.appendChild(soloPunto);
    solo.addEventListener('click', elegirSoloContar);
    elLista.appendChild(solo);
    CATEGORIAS.forEach(function (c, ci) {
      var cat = document.createElement('div');
      cat.className = 'cat' + (ci === catAbierta ? ' abierta' : '');

      var cab = document.createElement('button');
      cab.type = 'button'; cab.className = 'cat-cab';
      cab.setAttribute('aria-expanded', String(ci === catAbierta));
      var izq = document.createElement('span');
      izq.innerHTML = '<span class="cat-nombre"></span><span class="cat-sub"></span>';
      izq.querySelector('.cat-nombre').textContent = c.nombre;
      izq.querySelector('.cat-sub').textContent = c.sub;
      var chev = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      chev.setAttribute('class', 'cat-chevron'); chev.setAttribute('viewBox', '0 0 8 8'); chev.setAttribute('aria-hidden', 'true');
      chev.innerHTML = '<path d="M2 1l4 3-4 3" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>';
      cab.appendChild(izq); cab.appendChild(chev);
      cab.addEventListener('click', function () {
        catAbierta = (catAbierta === ci) ? -1 : ci;
        construirLista();
      });
      cat.appendChild(cab);

      var cont = document.createElement('div');
      cont.className = 'cat-mantras';
      MANTRAS.forEach(function (m) {
        if (m.cat !== ci) { return; }
        var fila = document.createElement('button');
        fila.type = 'button';
        fila.className = 'mantra-fila' + (m.id === estado.mantraId ? ' es-elegido' : '');
        var info = document.createElement('span');
        info.innerHTML = '<span class="mf-nombre"></span><span class="mf-texto"></span>';
        info.querySelector('.mf-nombre').textContent = m.nombre;
        info.querySelector('.mf-texto').textContent = m.largo ? m.linea1 : m.texto;
        var punto = document.createElement('span'); punto.className = 'mf-punto';
        fila.appendChild(info); fila.appendChild(punto);
        fila.addEventListener('click', function () { abrirDetalle(m.id); });
        cont.appendChild(fila);
      });
      cat.appendChild(cont);
      elLista.appendChild(cat);
    });
  }

  /* ===================== el detalle del mantra (los 10 campos de la V2) =====================
     Arriba lo de siempre (mantra completo + fonética + esencia); debajo, con tipografía menor, las cuatro
     casas que enseñan y el puente discreto. Solo el cuerpo se desplaza; la pantalla nunca. */
  var elDetalleCat = document.getElementById('detalle-cat');
  var elDetalleCuerpo = document.getElementById('detalle-cuerpo');
  var elBtnElegir = document.getElementById('btn-elegir');
  var mantraEnDetalle = 'om';
  function abrirDetalle(id) {
    var m = mantraPorId(id);
    mantraEnDetalle = id;
    catAbierta = m.cat;
    elDetalleCat.textContent = CATEGORIAS[m.cat].nombre;
    elDetalleCuerpo.innerHTML = '';
    function agrega(clase, texto) {
      var el = document.createElement('p'); el.className = clase;
      el.textContent = texto;
      elDetalleCuerpo.appendChild(el);
      return el;
    }
    // una casa que enseña: etiqueta de oro + párrafo menor (se omite si no hay cuerpo)
    function seccion(etiqueta, cuerpo) {
      if (!cuerpo) { return; }
      var wrap = document.createElement('div'); wrap.className = 'det-seccion';
      var e = document.createElement('p'); e.className = 'det-etiqueta'; e.textContent = etiqueta;
      var p = document.createElement('p'); p.className = 'det-parrafo'; p.textContent = cuerpo;
      wrap.appendChild(e); wrap.appendChild(p);
      elDetalleCuerpo.appendChild(wrap);
    }
    agrega('det-trad', 'tradición ' + m.tradicion);
    agrega('det-nombre', m.nombre);
    agrega('det-mantra', m.texto);          // el mantra completo (los largos también, aquí sí caben)
    agrega('det-fonetica', m.fonetica);
    agrega('det-esencia', m.esencia);
    if (m.nota) { var n = agrega('det-esencia', m.nota); n.style.opacity = '.7'; n.style.fontSize = '.8rem'; }
    if (m.aclara) { agrega('det-aclara', m.aclara); }   // el Om que aparece dos veces se aclara aquí
    seccion('Palabra por palabra', m.palabra);
    seccion('El origen', m.origen);
    seccion('Cuándo acompaña', m.cuando);
    seccion('La cuenta tradicional', m.cuenta);
    if (m.puente) { agrega('det-puente', 'Puente · ' + m.puente); }
    elDetalleCuerpo.scrollTop = 0;          // cada mantra abre desde arriba
    mostrarCara('cara-detalle');
  }
  elBtnElegir.addEventListener('click', function () {
    estado.mantraId = mantraEnDetalle;
    if (estado.modo === 'respiracion') { estado.modo = 'mantra'; }
    guardar();
    aplicaModo();
    pintar();
    mostrarCara('cara-practica');
  });

  /* ===================== "que el universo elija" (ceremonia quieta, de japa) =====================
     Nada de la fanfarria del contador: unas cuantas consideraciones tenues entre categorías, cada vez
     más lentas, y el elegido baja al centro. Sonido apenas presente, respetando el apagador. */
  var elVelo = document.getElementById('universo-velo');
  var elVeloNombre = document.getElementById('universo-nombre');
  var elVeloMantra = document.getElementById('universo-mantra');
  var elVeloSusurro = document.getElementById('universo-susurro');
  var ceremoniaCorriendo = false;
  var timersCeremonia = [];
  function notaTenue() {
    if (!sonidoOn) { return; }
    var a = ctxAudio(); if (!a || !masterGain) { return; }
    var t = a.currentTime + 0.001;
    var o = a.createOscillator(), g = a.createGain();
    o.type = 'sine';
    o.frequency.value = BASE_HZ * Math.pow(2, (Math.floor(Math.random() * 8)) / 12);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.05, t + 0.03);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.5);
    o.connect(g).connect(masterGain);
    o.start(t); o.stop(t + 0.55);
  }
  function universoElige() {
    if (ceremoniaCorriendo) { return; }
    ceremoniaCorriendo = true;
    timersCeremonia = [];
    despertarSesion(); ctxAudio();
    elVeloSusurro.textContent = 'El universo considera';
    elVeloMantra.textContent = '';
    elVelo.classList.add('activo'); elVelo.setAttribute('aria-hidden', 'false');
    var elegido = MANTRAS[Math.floor(Math.random() * MANTRAS.length)];
    // una secuencia que desacelera: intervalos crecientes hasta posarse
    var esperas = mqReduce.matches ? [400, 700] : [150, 190, 240, 300, 380, 480, 620, 800];
    var i = 0;
    function considera() {
      var m = (i >= esperas.length) ? elegido : MANTRAS[Math.floor(Math.random() * MANTRAS.length)];
      elVeloNombre.classList.add('tenue');
      timersCeremonia.push(window.setTimeout(function () {
        elVeloNombre.textContent = m.nombre;   // BUG 2: el nombre corto (nunca el texto completo gigante)
        elVeloNombre.classList.remove('tenue');
        notaTenue();
        vibrar(8);
      }, mqReduce.matches ? 0 : 120));
      if (i >= esperas.length) { timersCeremonia.push(window.setTimeout(posar, 900)); return; }
      timersCeremonia.push(window.setTimeout(considera, esperas[i]));
      i++;
    }
    function posar() {
      elVeloSusurro.textContent = 'El universo eligió';
      elVeloNombre.textContent = elegido.nombre;   // BUG 2: el nombre corto tambien al posarse (el texto vive en la practica y en la barra)
      elVeloMantra.textContent = elegido.largo ? elegido.linea1 : elegido.esencia;
      if (sonidoOn && audioCtx) { latido(audioCtx.currentTime + 0.2); }
      timersCeremonia.push(window.setTimeout(function () {
        estado.mantraId = elegido.id;
        if (estado.modo === 'respiracion') { estado.modo = 'mantra'; }
        guardar(); aplicaModo(); pintar();
        elVelo.classList.remove('activo'); elVelo.setAttribute('aria-hidden', 'true');
        ceremoniaCorriendo = false;
        mostrarCara('cara-practica');
      }, mqReduce.matches ? 700 : 1500));
    }
    considera();
  }
  document.getElementById('btn-universo').addEventListener('click', universoElige);
  elVelo.addEventListener('click', function () {
    /* un toque abandona la ceremonia sin elegir: los timers se barren y el velo se retira */
    if (!ceremoniaCorriendo) { return; }
    for (var k = 0; k < timersCeremonia.length; k++) { window.clearTimeout(timersCeremonia[k]); }
    timersCeremonia = [];
    elVelo.classList.remove('activo'); elVelo.setAttribute('aria-hidden', 'true');
    ceremoniaCorriendo = false;
  });

  /* ===================== la pantalla del hito (momento dorado, mas quieto) =====================
     Otra pantalla que la ceremonia del volteo: un velo dorado de la misma familia, con el numero de
     vueltas grande, la linea que le da sentido y una reverencia lenta. Sin sonido nuevo: reutiliza la
     nota tenue ya existente (gain bajo), respetando el apagador. Se cierra con un toque. */
  var elHitoVelo = document.getElementById('hito-velo');
  var elHitoNumero = document.getElementById('hito-numero');
  var elHitoSentido = document.getElementById('hito-sentido');
  var hitoTimer = null;
  function revelaHito(v, real) {
    // real=true: llega tras la ceremonia (con su nota tenue); real=false: ensayo del cuarto de pruebas (sin sonido)
    var sentido = HITOS[v];
    if (!sentido) { return; } // fuera de la serie, o despues de 1111: silencio, sin pantalla
    elHitoNumero.textContent = v;
    elHitoSentido.textContent = sentido;
    /* >>> parche gen (japa-invita-hito) >>> */
    if (!document.getElementById('hito-invita')) {
      var invitaP = document.createElement('p');
      invitaP.className = 'hito-invita';
      invitaP.id = 'hito-invita';
      invitaP.innerHTML = 'La rueda también vive en las manos: <a href="/collections/japa-malas" id="hito-invita-a">los Japa Malas de la casa</a>.';
      var invitaA = invitaP.querySelector('#hito-invita-a');
      if (invitaA) { invitaA.addEventListener('click', function (e) { e.stopPropagation(); }); }
      elHitoSentido.parentNode.insertBefore(invitaP, elHitoSentido.nextSibling);
    }
    /* <<< parche gen (japa-invita-hito) <<< */
    elHitoVelo.classList.add('activo');
    elHitoVelo.setAttribute('aria-hidden', 'false');
    if (real && sonidoOn) { notaTenue(); }
  }
  function cierraHito() {
    if (hitoTimer) { window.clearTimeout(hitoTimer); hitoTimer = null; }
    elHitoVelo.classList.remove('activo');
    elHitoVelo.setAttribute('aria-hidden', 'true');
  }
  elHitoVelo.addEventListener('click', cierraHito);

  /* ===================== el cuarto de pruebas (5 toques en el contador de vueltas) =====================
     Gotcha permanente: los parámetros de URL jamás llegan al contenido del artifact. Toda semilla es
     un botón interno. */
  var toquesPill = [];
  elPildora.addEventListener('click', function () {
    var t = Date.now();
    toquesPill = toquesPill.filter(function (x) { return t - x < 2600; });
    toquesPill.push(t);
    if (toquesPill.length >= 5) { toquesPill = []; abreCuartoPruebas(); }
  });
  function irAVuelta(vuelta) { // "vuelta" = la que se vive (1..7); completadas = vuelta - 1, para ver su chakra puro
    estado.vueltas = Math.max(0, vuelta - 1);
    estado.vueltasHoyDia = HOY_STR; estado.vueltasHoyN = estado.vueltas;
    estado.cuenta = 0; estado.sentido = 1; empezado = true; enCima = false;
    guardar(); pintar();
  }
  function irAPleno() { // tras la 7ª: el blanco dorado pleno que se queda
    estado.vueltas = 7;
    estado.vueltasHoyDia = HOY_STR; estado.vueltasHoyN = 7;
    estado.cuenta = 0; estado.sentido = 1; empezado = true; enCima = false;
    guardar(); pintar();
  }
  function muestraMirilla() {
    var previa = document.getElementById('mp-mirilla');
    if (previa) { previa.remove(); }
    var diag = document.createElement('pre');
    diag.id = 'mp-mirilla';
    diag.style.cssText = 'position:fixed;inset:auto 8px 64px 8px;z-index:98;max-height:50vh;overflow:auto;background:rgba(12,10,7,.96);color:#E8E0D0;border:1px solid rgba(201,169,97,.5);border-radius:10px;padding:10px;font-size:10px;line-height:1.5;white-space:pre-wrap;word-break:break-all;';
    var cruda = null;
    try { cruda = localStorage.getItem(LLAVE); } catch (e2) { cruda = 'SIN ACCESO: ' + e2.message; }
    diag.textContent = 'MIRILLA (toca para cerrar)\nHOY: ' + HOY_STR
      + '\nempezado: ' + empezado + '  número pasada: ' + numeroPasada()
      + '\nmemoria: ' + (cruda || '(vacio)');
    diag.addEventListener('click', function () { diag.remove(); });
    root.appendChild(diag);
  }
  function abreCuartoPruebas() {
    if (document.getElementById('mp-pruebas')) { return; }
    var caja = document.createElement('div');
    caja.id = 'mp-pruebas';
    caja.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;z-index:99;background:rgba(12,10,7,.97);border:1px solid rgba(201,169,97,.5);border-radius:12px;padding:12px;display:flex;flex-wrap:wrap;gap:8px;justify-content:center;';
    function boton(txt, fn) {
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = txt;
      b.style.cssText = 'font-family:inherit;font-size:.72rem;color:#F1DFAE;background:rgba(201,169,97,.12);border:1px solid rgba(201,169,97,.45);border-radius:999px;padding:8px 12px;cursor:pointer;';
      b.addEventListener('click', fn);
      caja.appendChild(b);
    }
    boton('Ir a 108 (ver la reversa)', function () {
      empezado = true; enCima = false; estado.cuenta = 106; estado.sentido = 1;
      elGuia.textContent = 'Toca una vez para ver el volteo en el gurú y la reversa.';
      guardar(); pintar();
    });
    boton('Ir a cuenta 26 (marcador 27)', function () {
      empezado = true; enCima = false; estado.cuenta = 25; estado.sentido = 1; // el próximo toque toca la cuenta 27
      elGuia.textContent = 'Toca una vez para oír el marcador sagrado 27.';
      guardar(); pintar();
    });
    boton('Ir a cuenta 43 (marcador 45)', function () {
      empezado = true; enCima = false; estado.cuenta = 43; estado.sentido = 1; // el próximo toque toca la cuenta 45, el de los códigos
      elGuia.textContent = 'Toca una vez para oír el marcador 45, el de los Códigos Sagrados.';
      guardar(); pintar();
    });
    boton('Vuelta 3 · plexo dorado', function () { irAVuelta(3); });
    boton('Vuelta 6 · tercer ojo índigo', function () { irAVuelta(6); });
    boton('Vuelta 7 · corona violeta', function () { irAVuelta(7); });
    boton('Tras la 7ª · blanco pleno', function () { irAPleno(); });
    boton('Vueltas a 8 (la próxima = hito 9)', function () {
      // deja vueltas en 8 SIN disparar hito (no pasa por registrarVuelta) y la mala a un toque del gurú:
      // el próximo cierre real hace vueltas=9, entra a la serie y el hito llega tras la ceremonia.
      estado.vueltas = 8; estado.vueltasHoyDia = HOY_STR; estado.vueltasHoyN = 8;
      estado.cuenta = 106; estado.sentido = 1; empezado = true; enCima = false; hitoPendiente = 0;
      elGuia.textContent = 'Toca una vez: al voltear en el gurú se cierra la vuelta 9 y, tras la ceremonia, sube el hito.';
      guardar(); pintar();
    });
    boton('Ensayo del hito 108 (solo pantalla, sin tocar datos)', function () {
      // solo revela la pantalla del hito; jamás toca estado.vueltas ni el disco.
      revelaHito(108, true);
    });
    boton('Ciclo auto veloz (propuesta)', function () {
      estado.modo = 'respiracion'; estado.modoAuto = true; estado.ritmoCiclo = 6;
      elChipAuto.classList.add('activo'); elChipAuto.setAttribute('aria-pressed', 'true');
      elCtrlRitmo.value = 6; aplicaRitmoLbl();
      elMarcaLinea.textContent = 'modo automático · el círculo respira y cuenta solo (propuesta)';
      despertarSesion(); ctxAudio();
      guardar(); aplicaModo(); pintar();
    });
    boton('Ver memoria', muestraMirilla);
    boton('Borrar memoria', function () {
      try { localStorage.removeItem(LLAVE); } catch (e) {}
      estado.cuenta = 0; estado.sentido = 1; estado.vueltas = 0;
      estado.vueltasHoyDia = null; estado.vueltasHoyN = 0;
      estado.modoAuto = false; estado.marcadoresOn = true;
      empezado = false; enCima = false;
      elChipAuto.classList.remove('activo'); elChipAuto.setAttribute('aria-pressed', 'false');
      elChipMarcadores.classList.add('activo'); elChipMarcadores.setAttribute('aria-pressed', 'true');
      elVisual.classList.remove('marcadores-off');
      elMarcaLinea.textContent = '';
      guardar(); pintar(); muestraMirilla();
    });
    boton('Cerrar', function () {
      var m = document.getElementById('mp-mirilla'); if (m) { m.remove(); }
      caja.remove();
    });
    root.appendChild(caja);
  }
  try { if (/[?&]memoria=ver(?:&|=|$)/.test(QS)) { muestraMirilla(); } } catch (e) {}

  /* ===================== arranque ===================== */
  cargar();
  /* >>> parche gen (japa-semilla-mantra) >>> */
  try {
    var mSemillaJapa = QS.match(/[?&]mantra=([^&]+)/);
    var idSemilla = mSemillaJapa ? decodeURIComponent(mSemillaJapa[1].split('+').join('%20')).trim() : '';
    if (idSemilla && idSemilla !== 'libre') {
      var mSem = null;
      for (var iS = 0; iS < MANTRAS.length; iS++) { if (MANTRAS[iS].id === idSemilla) { mSem = MANTRAS[iS]; break; } }
      if (mSem) { estado.mantraId = mSem.id; estado.modo = 'mantra'; guardar(); }
    } else if (!empezado && estado.mantraId === 'om') {
      var doyJapa = Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0).getTime()) / 86400000);
      estado.mantraId = MANTRAS[doyJapa % MANTRAS.length].id;
    }
  } catch (e) { /* semilla opcional */ }
  /* <<< parche gen (japa-semilla-mantra) <<< */
  construirRueda();
  elVisual.classList.toggle('marcadores-off', !estado.marcadoresOn);
  elChipMarcadores.classList.toggle('activo', estado.marcadoresOn);
  elChipMarcadores.setAttribute('aria-pressed', String(estado.marcadoresOn));
  elChipAuto.classList.toggle('activo', estado.modoAuto);
  elChipAuto.setAttribute('aria-pressed', String(estado.modoAuto));
  elChipFondo.classList.toggle('activo', fondoOn); // el chip 432, segun mp_japa_afinacion_v1 cargado al arranque
  elChipFondo.setAttribute('aria-pressed', String(fondoOn));
  elCtrlRitmo.value = estado.ritmoCiclo; aplicaRitmoLbl();
  pintarVoces();
  if (estado.modoAuto) { elMarcaLinea.textContent = 'modo automático · el círculo respira y cuenta solo (propuesta)'; }
  aplicaModo();
  pintar();

  } catch (e) {
    try { document.documentElement.classList.remove('mp-app'); } catch (_e) {}
    try { var r2 = document.querySelector('[data-mp-japa] [data-room]'); if (r2) { r2.hidden = true; } } catch (_e2) {}
    if (window.MP_QA === true) { throw e; }
  }
})();

